import {
  Alert,
  Fieldset,
  Button,
  Flex,
  SearchField,
  Text,
  TextField,
} from "@aws-amplify/ui-react";
import FlexFormContainer from "../common/FlexFormContainer";
import { useState } from "react";
import { useCareGiverInvitePostMutation } from "./api/useCareGiversMutation";
import { useUserQuery } from "../common/useUserQuery";

export default function CareGiversInvitePage() {
  const { data: userQueryData } = useUserQuery();
  const [email, setEmail] = useState(null);
  const [inviteEmails, setInviteEmails] = useState([]);
  const {
    mutate: careGiverInvitePostMutation,
    isLoading: isLoadingInviteMutatation,
    isSuccess: isSuccessInviteMutatation,
  } = useCareGiverInvitePostMutation();

  const handleSendInvite = () => {
    console.log("Send all these invites", inviteEmails);
    careGiverInvitePostMutation({
      patientUserId: userQueryData.patientUserId,
      emails: inviteEmails,
    });
  };

  const handleRemoveEmail = (email, index) => {
    console.log("Remove this email: ", { email, index });
    let cloneArray = Object.assign([], inviteEmails);
    cloneArray.splice(index, 1);
    setInviteEmails(cloneArray);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inviteEmails?.length < 3) {
      setInviteEmails((prev) => [...prev, email]);
      setEmail(null);
    }
  };

  return (
    <>
      <FlexFormContainer headerTitle={"Invite Caregiver"}>
        <Flex direction={"column"}>
          {isSuccessInviteMutatation && (
            <Alert variation="success" isDismissible={true} hasIcon={true}>
              Invitation(s) successfully sent
            </Alert>
          )}
          <Alert variation="info" hasIcon={false}>
            Please enter the emails you would like to send invites to caregive
            into your account. Max emails allowed are (3) per request
          </Alert>
        </Flex>

        <form onSubmit={handleSubmit}>
          <Flex
            direction={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            alignContent={"center"}
          >
            <TextField
              disabled={inviteEmails?.length >= 3}
              placeholder="Enter a valid email..."
              type="email"
              isRequired
              value={email || ""}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Flex marginTop={7}>
              <Button type="submit" disabled={inviteEmails?.length >= 3}>
                Add
              </Button>
            </Flex>
          </Flex>
        </form>
        <Flex gap={9} direction={"column"}>
          {inviteEmails?.map((e, i) => (
            <Flex
              key={`cgip_ie_${e}_${i}`}
              alignItems={"center"}
              backgroundColor={"rgb(233, 249, 252)"}
              paddingLeft={15}
              paddingRight={15}
              paddingTop={9}
              paddingBottom={9}
              borderRadius={12}
            >
              <Text>{e}</Text>
              <Button
                size="small"
                colorTheme="overlay"
                onClick={() => handleRemoveEmail(e, i)}
              >
                X
              </Button>
            </Flex>
          ))}
        </Flex>

        {(inviteEmails?.length > 0 && inviteEmails?.length <= 3) && (
          <Button
            variation="primary"
            onClick={handleSendInvite}
            isLoading={isLoadingInviteMutatation}
            disabled={isLoadingInviteMutatation}
          >
            Invite
          </Button>
        )}
      </FlexFormContainer>
    </>
  );
}
